import { BrowserRouter, Switch, Route } from "react-router-dom";
import Navbar from "./components/NavBar";
import Home from "./containers/Home";
import Marketplace from "./containers/Marketplace";
import Login from "./containers/Login";
import Signup from "./containers/Signup";
import SignupClient from "./containers/Signup/Client";
import SignupEntrepreneur from "./containers/Signup/Entrepreneur";
import Product from "./containers/Marketplace/Product";
import Terms from "./containers/Terms";
import NotFound from "./containers/NotFound";
import Store from "./containers/Marketplace/Store";
import Evento from "./containers/Admin/evento";
import NewPassword from "./containers/Password/NewPassword";
import ForgotPassword from "./containers/Password/ForgotPassword";
import Purchases from "./containers/Purchases";
import Account from "./containers/Account";
import Entrepreneur from "./containers/Entrepreneur";
import EntDashboard from "./containers/Entrepreneur/Dashboard";
import EntOrders from "./containers/Entrepreneur/Orders";
import EntProducts from "./containers/Entrepreneur/Products";
import EntGiftvoucher from "./containers/Entrepreneur/Giftvoucher";
import Admin from "./containers/Admin";
import AdminDashboard from "./containers/Admin/Dashboard";
import AdminUsers from "./containers/Admin/Users";
import AdminPayments from "./containers/Admin/Payments";
import AdminLocations from "./containers/Admin/Locations";
import AdminCategories from "./containers/Admin/Categories";
import AdminRibbonBadges from "./containers/Admin/ribbonBadges";
import AdminTypesCategories from './containers/Admin/typesCategories';
import AdminPartner from './containers/Admin/partners';
import AdminBanner from './containers/Admin/banners';
import AdminProducts from './containers/Admin/products';
import Contact from "./containers/Contact";
import ConfirmTerms from "./components/ConfirmTerms";
import Checkout from "./containers/Checkout";
import EntConfPayment from "./containers/Entrepreneur/ConfirmPayment";
import EntLoyaltyCards from "./containers/Entrepreneur/LoyaltyCards";
import LoyaltyCards from "./containers/LoyaltyCards";
import Giftvoucher from "./containers/Giftvoucher";
import Voucher from "./containers/Marketplace/Voucher";
import AddProductPage from "./containers/AddProductPage/AddProductPage";
import AddProductAssistantPage from "./containers/AddProductAssistantPage";
import GruposOfertas, { GruposShopee, GruposPet, GruposGames, GruposFerramentas, GruposTvs, GruposPerfumes } from "./containers/Admin/GruposAdmin/GruposAdmin";
import AdminLeads from "./containers/Admin/Leads";

import AdminAutomation from "./containers/Admin/Automation";
import AdminMessageHistory from "./containers/Admin/MessageHistory";
import AdminDivugacao from './containers/Admin/Divulgacao';
import Grupos from "./containers/Grupos";
import GeralPage from "./containers/Grupos/GeralPage";
import PetPage from "./containers/Grupos/PetPage";
import GamesPage from "./containers/Grupos/GamesPage";
import FerramentasPage from "./containers/Grupos/FerramentasPage";
import TvsPage from "./containers/Grupos/TvsPage";
import PerfumesPage from "./containers/Grupos/PerfumesPage";
import OfertasAoVivo from "./containers/OfertasAoVivo";
import ProductRequestForm from "./containers/ProductRequestForm";
import AdminThemeSettings from "./containers/Admin/ThemeSettings";
import AdminWhatsAppWebChannels from "./containers/Admin/WhatsAppWeb/Channels";
import AdminWhatsAppWebGroups from "./containers/Admin/WhatsAppWeb/Groups";
import AdminWhatsAppWebSegments from "./containers/Admin/WhatsAppWeb/Segments";
import AdminWhatsAppWebQuickSender from "./containers/Admin/WhatsAppWeb/QuickSender";
import AdminWhatsAppWebCampaigns from "./containers/Admin/WhatsAppWeb/Campaigns";
import AdminWhatsAppWebIntegrations from "./containers/Admin/WhatsAppWeb/Integrations";
import AdminWhatsAppWebMultiSender from "./containers/Admin/WhatsAppWeb/MultiSender";
import AdminWhatsAppWebTemplates from "./containers/Admin/WhatsAppWeb/Templates";
import AdminWhatsAppWebBlacklist from "./containers/Admin/WhatsAppWeb/Blacklist";
import AdminWhatsAppWebMonitoring from "./containers/Admin/WhatsAppWeb/Monitoring";
import AdminWhatsAppWebStatistics from "./containers/Admin/WhatsAppWeb/Statistics";
import AdminWhatsAppWebService from "./containers/Admin/WhatsAppWeb/Service";
import AdminWhatsAppWebContacts from "./containers/Admin/WhatsAppWeb/Contacts";
export default function Routes() {
  return (
    <BrowserRouter>
      <Navbar />
      {/* TODO: Page Tracking GA */}

      <Switch>
        {/* <Route exact path="/" component={Home} /> */}

        {/*<PrivateRoute exact path="/" component={Marketplace} />*/}
        <Route exact path="/" component={Marketplace} />
        {/*<Route exact path="/adicionar-oferta" component={AddProductPage} />*/}
        <Route exact path="/adicionar-oferta-ia" component={AddProductAssistantPage} />

        <Route path="/sobre" component={Home} />
        <Route path="/entrar" component={Login} />
        <Route path="/cadastro/cliente" component={SignupClient} />
        <Route path="/cadastro/empreendedor" component={SignupEntrepreneur} />
        <Route path="/cadastro" component={Signup} />
        <Route path="/recuperar" component={ForgotPassword} />
        <Route path="/redefinir/:token" component={NewPassword} />
        <Route path="/conta" component={Account} />
        <Route path="/checkout" component={Checkout} />
        <Route path="/produto/:id" component={Product} />
        <Route path="/giftvoucher/:id" component={Voucher} />
        <Route path="/loja/:id" component={Store} />
        <Route path="/categoria/:idCategory" component={Marketplace} />
        <Route path="/subCategory/:subCat" component={Marketplace} />
        {/* <Route path="/marketplace/" component={Marketplace} /> */}
        {/* Pedir Produto desativado temporariamente - reativar quando ferramenta voltar */}
        {/* <Route path="/pedir-produto" component={ProductRequestForm} /> */}
        <Route path="/parceiros/" component={Giftvoucher} />
        <Route path="/grupos/pet" component={PetPage} />
        <Route path="/grupos/games" component={GamesPage} />
        <Route path="/grupos/ferramentas" component={FerramentasPage} />
        <Route path="/grupos/tvs" component={TvsPage} />
        <Route path="/grupos/perfumes" component={PerfumesPage} />
        <Route path="/grupos/:slug" component={GeralPage} />
        <Route path="/grupos/" component={Grupos} />
        <Route path="/ofertas-ao-vivo" component={OfertasAoVivo} />
        <Route path="/compras" component={Purchases} />
        <Route path="/fidelidade" component={LoyaltyCards} />
        <Route path="/politica-privacidade" component={Terms} />
        <Route path="/contato" component={Contact} />
        <Route path="/poster/fidelidade" component={EntLoyaltyCards} />
        <Route path="/poster/dashboard" component={EntDashboard} />
        <Route path="/poster/pedidos" component={EntOrders} />
        <Route path="/poster/produtos" component={EntProducts} />
        <Route path="/poster/giftvoucher" component={EntGiftvoucher} />
        <Route path="/poster/pedido/:id" component={EntConfPayment} />
        <Route path="/poster/leads" component={AdminLeads} />

        <Route path="/poster/automacao-whatsapp" component={AdminAutomation} />
        <Route path="/poster/historico-mensagens" component={AdminMessageHistory} />
        <Route path="/poster" component={Entrepreneur} />
        <Route path="/admin/evento" component={Evento} />

        <Route path="/admin/dashboard" component={AdminDashboard} />
        <Route path="/admin/usuarios" component={AdminUsers} />
        <Route path="/admin/pagamentos" component={AdminPayments} />
        <Route path="/admin/localidades" component={AdminLocations} />
        <Route path="/admin/categorias" component={AdminCategories} />
        <Route path="/admin/grupos/pet" component={GruposPet} />
        <Route path="/admin/grupos/games" component={GruposGames} />
        <Route path="/admin/grupos/ferramentas" component={GruposFerramentas} />
        <Route path="/admin/grupos/tvs" component={GruposTvs} />
        <Route path="/admin/grupos/perfumes" component={GruposPerfumes} />
        <Route path="/admin/grupos" component={GruposOfertas} />
        <Route path="/admin/controle/shoppe" component={GruposShopee} />
        <Route path="/admin/ribbon-badges" component={AdminRibbonBadges} />
        <Route path="/admin/tipos-categorias" component={AdminTypesCategories} />
        <Route path="/admin/parceiros" component={AdminPartner} />
        <Route path="/admin/banner" component={AdminBanner} />
        <Route path="/admin/divulgacao/shoope" component={AdminDivugacao} />
        <Route path="/admin/products" component={AdminProducts} />
        <Route path="/admin/leads" component={AdminLeads} />

        <Route path="/admin/automacao-whatsapp" component={AdminAutomation} />
        <Route path="/admin/historico-mensagens" component={AdminMessageHistory} />
        <Route path="/admin/tema" component={AdminThemeSettings} />
        <Route path="/admin/whatsapp-web/canais" component={AdminWhatsAppWebChannels} />
        <Route path="/admin/whatsapp-web/grupos" component={AdminWhatsAppWebGroups} />
        <Route path="/admin/whatsapp-web/contatos" component={AdminWhatsAppWebContacts} />
        <Route path="/admin/whatsapp-web/segmentos" component={AdminWhatsAppWebSegments} />
        <Route path="/admin/whatsapp-web/quick-sender" component={AdminWhatsAppWebQuickSender} />
        <Route path="/admin/whatsapp-web/campanhas" component={AdminWhatsAppWebCampaigns} />
        <Route path="/admin/whatsapp-web/integracoes" component={AdminWhatsAppWebIntegrations} />
        <Route path="/admin/whatsapp-web/multi-sender" component={AdminWhatsAppWebMultiSender} />
        <Route path="/admin/whatsapp-web/templates" component={AdminWhatsAppWebTemplates} />
        <Route path="/admin/whatsapp-web/blacklist" component={AdminWhatsAppWebBlacklist} />
        <Route path="/admin/whatsapp-web/monitoramento" component={AdminWhatsAppWebMonitoring} />
        <Route path="/admin/whatsapp-web/estatisticas" component={AdminWhatsAppWebStatistics} />
        <Route path="/admin/whatsapp-web/servico" component={AdminWhatsAppWebService} />
        <Route path="/admin" component={Admin} />
        <Route component={NotFound} />
      </Switch>
      <ConfirmTerms />
    </BrowserRouter>
  );
}
